import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import {
    LayoutDashboard,
    CreditCard,
    Wrench,
    FileText,
    User,
    Menu,
    ChevronLeft,
    X
} from 'lucide-react';
import { ThemeToggle } from '../common/ThemeToggle';

const navItems = [
    { to: '/tenant', icon: LayoutDashboard, label: 'Dashboard', end: true },
    { to: '/tenant/profile', icon: User, label: 'My Profile' },
    { to: '/tenant/payments', icon: CreditCard, label: 'My Payments' },
    { to: '/tenant/maintenance', icon: Wrench, label: 'Maintenance' },
    { to: '/tenant/documents', icon: FileText, label: 'Documents' },
];

export const TenantLayout: React.FC = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen bg-light-bg dark:bg-dark-bg">
            {/* Mobile Sidebar Toggle */}
            <button
                className="md:hidden fixed top-4 left-4 z-50 p-2 bg-white dark:bg-black rounded-md shadow-md"
                onClick={() => setSidebarOpen(!sidebarOpen)}
            >
                {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
            </button>

            {/* Sidebar */}
            <div className={`
                fixed inset-y-0 left-0 z-40 w-64 bg-white dark:bg-black border-r border-light-border dark:border-dark-border transform transition-transform duration-200 ease-in-out md:relative md:translate-x-0
                ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
            `}>
                <div className="p-6 border-b border-light-border dark:border-dark-border">
                    <h2 className="text-xl font-bold text-primary dark:text-golden">Tenant Portal</h2>
                </div>
                <nav className="p-4 space-y-1">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            className={({ isActive }) => `
                                flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors
                                ${isActive
                                    ? 'bg-primary/10 text-primary dark:text-golden border border-primary/20'
                                    : 'text-light-text dark:text-dark-text hover:bg-light-card dark:hover:bg-dark-card'}
                            `}
                            onClick={() => setSidebarOpen(false)}
                        >
                            <item.icon size={18} />
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="p-4 border-t border-light-border dark:border-dark-border mt-auto space-y-2">
                    <NavLink
                        to="/"
                        className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium text-light-text dark:text-dark-text hover:bg-light-card dark:hover:bg-dark-card transition-colors"
                    >
                        <span className="flex items-center gap-2">
                            <ChevronLeft size={18} /> Back to Personal
                        </span>
                    </NavLink>
                </div>
            </div>

            {/* Main Content */}
            <div className="flex-1 overflow-auto relative">
                <div className="absolute top-4 right-4 z-50">
                    <ThemeToggle />
                </div>
                <div className="p-4 md:p-8 pt-16 md:pt-8 flex-1 flex flex-col items-center">
                    <div className="w-full max-w-7xl mx-auto">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};
